import BaseInfo from '@/model/modules/BaseInfo'

export default class UserGroupInfo extends BaseInfo {
  groupKey: string = ''
  groupName: string = ''
  description: string = ''
}
